<form [formGroup]="form" (ngSubmit)="submit()">
  <div class="form-group">
    <div class="input-row-group">
      <h1 mat-dialog-title>Nytt meddelande</h1>
    </div>
    <mat-dialog-content>

      <div class="input-row-group">

        <mat-form-field floatLabel="always" >
          <input type="text" placeholder="Mottagare" aria-label="Mottagare" matInput formControlName="userMapping" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayFn">
            <mat-option *ngFor="let userMapping of filteredUserMappings | async" [value]="userMapping">
              {{ userMapping.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-checkbox formControlName="sendToAll" style="max-width:140px;align-self:center">Skicka till alla</mat-checkbox>

      </div>


      <div class="input-group">
        <mat-form-field floatLabel="always">
          <mat-label>Rubrik</mat-label>
          <input type="text" matInput placeholder="Rubrik" formControlName="title">
        </mat-form-field>

        <mat-form-field floatLabel="always">
          <mat-label>Meddelande</mat-label>
          <textarea type="text" rows="4" matInput placeholder="Meddelande" formControlName="body"></textarea>
        </mat-form-field>


        <!-- Kräv svar checkbox -->
        <mat-checkbox class="" formControlName="replyRequired">Kräv svar</mat-checkbox>

      </div>

    </mat-dialog-content>
    <hr />
    <mat-dialog-actions>
      <button mat-raised-button type="submit" color="primary" [disabled]="!form.valid">Skicka</button>
      <button mat-raised-button type="button" color="primary" mat-dialog-close>Avbryt</button>
    </mat-dialog-actions>

  </div>

</form>
